import React, {Component} from 'react';
import {observer, inject} from "mobx-react";
import Loading from "../../Loading";
import LastComboBlock from "./LastComboBlock";
import { Link } from "react-router-dom";

class LastComboComments extends Component {
  componentDidMount() {
    this.props.commentsStore.loadLastComboComments();
  }
  makeUrl(to, child, props={}) {
    if(this.props.standalone) {
      return <a href={to} {...props}>{child}</a>
    } else {
      return <Link to={to} {...props}>{child}</Link>
    }
  }
  getBaseLastCommentsUrl() {
    if(this.props.standalone) {
      return "/comments/";
    } else {
      return "/last_comments/all/";
    }
  }
  render() {
    if(this.props.commentsStore.list.fetching || !this.props.commentsStore.list.inited) {
      return <Loading />;
    }
    return (
      <div className="up12-superSmall">
        <div className="up12 margin s-size-3">
          <div className="cell">
            <h3 className="pr hov" style={{paddingBottom:0}}>
              {this.makeUrl(`${this.getBaseLastCommentsUrl()}?cats=51`,"Фигурки",{ className:"b1 clear tdni db" })}
              <div className="pa pa-br mdi mdi-arrow-right op-hov pright5 trans03 arrowPull w3"></div>
            </h3>
            <LastComboBlock standalone={this.props.standalone} list={this.props.commentsStore.list.data.figures} />
          </div>
          <div className="cell">
            <h3 className="pr hov" style={{paddingBottom:0}}>
              {this.makeUrl(`${this.getBaseLastCommentsUrl()}?cats=56`,"Фото",{ className:"b1 clear tdni db" })}
              <div className="pa pa-br mdi mdi-arrow-right op-hov pright5 trans03 arrowPull w3"></div>
            </h3>
            <LastComboBlock standalone={this.props.standalone} list={this.props.commentsStore.list.data.photos} />
          </div>
          <div className="cell">
            <h3 className="pr hov" style={{paddingBottom:0}}>
              {this.makeUrl(`${this.getBaseLastCommentsUrl()}?cats=62`,"Блог посты",{ className:"b1 clear tdni db" })}
              <div className="pa pa-br mdi mdi-arrow-right op-hov pright5 trans03 arrowPull w3"></div>
            </h3>
            <LastComboBlock standalone={this.props.standalone} list={this.props.commentsStore.list.data.blog_posts} />
          </div>
          <div className="cell">
            <h3 className="pr hov" style={{paddingBottom:0}}>
              {this.makeUrl(`${this.getBaseLastCommentsUrl()}?cats=74`,"Аниме",{ className:"b1 clear tdni db" })}
              <div className="pa pa-br mdi mdi-arrow-right op-hov pright5 trans03 arrowPull w3"></div>
            </h3>
            <LastComboBlock standalone={this.props.standalone} list={this.props.commentsStore.list.data.anime} />
          </div>
          <div className="cell">
            <h3 className="pr hov" style={{paddingBottom:0}}>
              {this.makeUrl(`${this.getBaseLastCommentsUrl()}?cats=80`,"Персонажи",{ className:"b1 clear tdni db" })}
              <div className="pa pa-br mdi mdi-arrow-right op-hov pright5 trans03 arrowPull w3"></div>
            </h3>
            <LastComboBlock standalone={this.props.standalone} list={this.props.commentsStore.list.data.characters} />
          </div>
          <div className="cell">
            <h3 className="pr hov" style={{paddingBottom:0}}>
              {this.makeUrl(`${this.getBaseLastCommentsUrl()}?cats=52`,"Новости",{ className:"b1 clear tdni db" })}
              <div className="pa pa-br mdi mdi-arrow-right op-hov pright5 trans03 arrowPull w3"></div>
            </h3>
            <LastComboBlock standalone={this.props.standalone} list={this.props.commentsStore.list.data.news} />
          </div>
        </div>
      </div>
    )
  }
}

export default inject("commentsStore")(observer(LastComboComments));